export const loading = "loading";
export const success = "success";
export const failed = "failed";
